import { Injectable } from '@angular/core';

import DomainEventProvider from '../../../../../core/domain/events/domain_event_provider';
import { BillParamsEvent } from './bill-params-events';

@Injectable({ providedIn: 'root' })
export class BillParamsEventProvider extends DomainEventProvider<BillParamsEvent> {}
